import { Box, Typography } from '@material-ui/core';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

const EnvSticker = () => {
  const config = useApi(configApiRef);
  const currentEnvironment =
    config.getOptionalString('environments.current') || '';

  const isProduction = currentEnvironment === 'production';

  const environmentName =
    (
      {
        development: 'DEV',
        testing: 'MR',
      } as Record<string, string>
    )[currentEnvironment] || 'LOCAL';

  const isLocal = environmentName === 'LOCAL';

  return (
    !isProduction && (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 1,
          borderTop: '40px solid #f44336',
          borderRight: '40px solid transparent',
          zIndex: 9999999,
        }}
      >
        <Typography
          variant="caption"
          style={{
            position: 'fixed',
            top: isLocal ? '6px' : '5px',
            left: isLocal ? '0px' : '2px',
            transform: 'rotate(315deg)',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '10px',
          }}
        >
          {environmentName}
        </Typography>
      </Box>
    )
  );
};

export default EnvSticker;
